import { useEffect, useState } from 'react';
import { ButtonGroupDummyData } from '../../../../constants/stocks/apiResponseTypes';
import { ButtonVariants } from '../../../Atoms/Button';
import { ButtonGroup } from '../../../Molecules/ButtonGroup';
import { GoldSilverChart } from '../../../Molecules/stockChart';
import { relDiff } from '../../../Utils/UtilFunctions';
import { getButtonVariant } from '../../../stocks/details-page/Charts/utils';
import GoldSilverService from '../Service';

export const GoldChart = ({
  data,
  city,
  setChange,
  setPercentageChange,
}: {
  data: number[][];
  city: string;
  setChange?: React.Dispatch<
    React.SetStateAction<{ change22k: number; change24k: number }>
  >;
  setPercentageChange?: React.Dispatch<
    React.SetStateAction<{ change22k: number; change24k: number }>
  >;
}): JSX.Element => {
  const [graphData, setGraphData] = useState(data);
  const [carat, setCarat] = useState('24k');
  const [interval, setInterval] = useState('1W');

  const newCaratValues = ['18k', '14k', '12k', '9k'];
  const forbiddenIntervalsForNewCarats = ['3M', '6M'];

  const onCaratChange = async () => {
    try {
      if (
        newCaratValues.includes(carat) &&
        forbiddenIntervalsForNewCarats.includes(interval)
      ) {
        setInterval(() => '1W');
      }
      const data = await GoldSilverService.getGraphData(
        city,
        interval,
        `gold${carat}`
      );

      setGraphData(data);

      const [changeDataForRateCard22k, changeDataForRateCard24k] = [
        await GoldSilverService.getGraphData(city, interval, `gold22k`),

        await GoldSilverService.getGraphData(city, interval, `gold24k`),
      ];

      if (
        changeDataForRateCard22k &&
        changeDataForRateCard24k &&
        changeDataForRateCard22k.length >= 2 &&
        changeDataForRateCard24k.length >= 2
      ) {
        //for 22k
        const initialRate22k = Number(changeDataForRateCard22k[0][1]);
        const finalRate22k = Number(
          changeDataForRateCard22k[changeDataForRateCard22k.length - 1][1]
        );
        const percentageChange22k = parseFloat(
          (((finalRate22k - initialRate22k) / initialRate22k) * 100).toFixed(2)
        );

        //for 24k
        const initialRate24k = Number(changeDataForRateCard24k[0][1]);
        const finalRate24k = Number(
          changeDataForRateCard24k[changeDataForRateCard24k.length - 1][1]
        );
        const percentageChange24k = parseFloat(
          (((finalRate24k - initialRate24k) / initialRate24k) * 100).toFixed(2)
        );

        setChange({
          change22k: finalRate22k - initialRate22k,
          change24k: finalRate24k - initialRate24k,
        });
        setPercentageChange({
          change22k: percentageChange22k,
          change24k: percentageChange24k,
        });
      }
    } catch (error) {
      console.error('Error fetching gold price data:', error);
    }
  };

  useEffect(() => {
    if (
      newCaratValues.includes(carat) &&
      forbiddenIntervalsForNewCarats.includes(interval)
    ) {
      setInterval(() => '1W');
    }
    onCaratChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carat, interval]);

  const CAGR =
    graphData && graphData.length && graphData.length > 2
      ? relDiff(graphData[0]?.[1], graphData[graphData.length - 1]?.[1])
      : null;

  const isCAGRpos = CAGR ? CAGR >= 0 : null;

  return (
    <>
      <GoldSilverChart
        stockData={graphData ? [...graphData] : []}
        showTimeInToolTip={false}
        carat={carat}
        gram="10gm"
      ></GoldSilverChart>

      <div className="flex flex-row justify-between sm:flex-col sm:px-4 sm:justify-center">
        <ButtonGroup
          onClick={(e) => {
            const btn = e.target as HTMLInputElement;
            setCarat(() => `${btn.id}`);
          }}
          buttons={ButtonGroupDummyData.carat}
          className="py-3 flex-auto sm:py-2 sm:pl-0 sm:text-s-8 sm:mx-auto"
          variant={ButtonVariants.blue}
          buttonClassName="py-2 px-5 font-medium"
          defaultSelectedIndex={5}
        ></ButtonGroup>

        <ButtonGroup
          onClick={(e) => {
            const btn = e.target as HTMLInputElement;
            setInterval(() => btn.id);
          }}
          changeInterval={setInterval}
          buttons={
            newCaratValues.includes(carat)
              ? ButtonGroupDummyData.intervals2
              : ButtonGroupDummyData.intervals1
          }
          className="py-3  sm:py-2 sm:pl-0 sm:text-s-8 sm:mx-auto"
          variant={getButtonVariant(isCAGRpos)}
          buttonClassName="py-2 px-5 font-medium sm:py-1.5 sm:px-3"
        ></ButtonGroup>
      </div>
    </>
  );
};
